module.exports = __webpack_public_path__ + "img/Feature.3d254b56.jpg";